import type { ProjectId, WellId } from 'common/types'

import { constructClientDispenser } from '../clientDispenserFactory'
import { axiosInstance } from '../common'
import { BackgroundWellsDataImportClient } from './__generated__/BackgroundWellsDataImport'
import { HttpClient } from './__generated__/http-client'

const Clients = {
  BackgroundWellsDataImportClient,
}

const getClient = constructClientDispenser(Clients, HttpClient, axiosInstance)

export const importAllWellsDataFromGeoDBApi = (
  projectId: ProjectId,
  wellIds: WellId[],
): Promise<string> => {
  const client = getClient('BackgroundWellsDataImportClient')
  return client.backgroundWellsDataImportStartImportAllWellsData(wellIds, { projectId })
}

export const stopWellsDataImportTaskApi = (taskId: string): Promise<void> => {
  const client = getClient('BackgroundWellsDataImportClient')
  return client.backgroundWellsDataImportStopWork(taskId)
}
